// Navigation items for LEPR project

import {
  DashboardIcon,
  MessagesIcon,
  ReportCalendar,
  StoresIcon,
  TaxSettingsIcon,
  TransactionsIcon,
} from '../../components/MainNavigation/icons'
import EPRReportingIcon from '../../components/MainNavigation/icons/EPRReportingIcon'
import { getCombinedSettingsMessageCount } from 'utils/settingsNavBadgeCount'
import { SANDBOX_FEATURE } from '../../helpers/sandboxAccess'
import { isDevelopment } from '../../utils/environment'

/** Same host rule as Tax/Sandbox: localhost and *.dev, hidden on prod. */
const isReportCalendarMenuVisible = () => isDevelopment()

/**
 * Get navigation items for LEPR project
 * @param {Object} context - Context object with location, t, newMessagesCount
 * @returns {Array} Array of navigation items
 */
export const getLEPRNavigationItems = (context) => {
  const { location, t, newMessagesCount = {} } = context

  const printMessagesCount = (count) => {
    if (count) {
      return count
    }
    return null
  }

  return [
    {
      url: '/home',
      label: t('menu.home'),
      icon: () => <DashboardIcon selected={location.pathname.startsWith('/home')} />,
      selected: location.pathname.startsWith('/home'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/transactions',
      label: t('menu.transactions'),
      icon: () => <TransactionsIcon selected={location.pathname.startsWith('/transactions')} />,
      badge: printMessagesCount(newMessagesCount.transactions),
      selected: location.pathname.startsWith('/transactions'),
      isTaxAgentMainVisible: false,
    },
    {
      url: '/epr-reporting',
      label: 'EPR declarations',
      icon: () => <EPRReportingIcon selected={location.pathname.startsWith('/epr-reporting')} />,
      badge: printMessagesCount(newMessagesCount['epr-report']),
      selected: location.pathname.startsWith('/epr-reporting'),
    },
    {
      url: '/report-calendar',
      label: t('menu.reportCalendar'),
      icon: () => <ReportCalendar selected={location.pathname.startsWith('/report-calendar')} />,
      selected: location.pathname.startsWith('/report-calendar'),
      sandboxFeature: SANDBOX_FEATURE.REPORT_CALENDAR,
      isTaxAgentMainVisible: false,
      filterCondition: isReportCalendarMenuVisible,
    },
    {
      url: '/messages',
      label: t('menu.messages'),
      icon: () => <MessagesIcon selected={location.pathname.startsWith('/messages')} />,
      badge: printMessagesCount(newMessagesCount.messages),
      selected: location.pathname.startsWith('/messages'),
      sandboxFeature: SANDBOX_FEATURE.MESSAGES,
      isTaxAgentMainVisible: true,
    },
    {
      url: '/settings',
      label: 'SETTINGS',
      icon: () => <TaxSettingsIcon selected={location.pathname.startsWith('/settings')} />,
      badge: printMessagesCount(
        getCombinedSettingsMessageCount(newMessagesCount, 'merchant_settings')
      ),
      selected: location.pathname.startsWith('/settings'),
      isTaxAgentMainVisible: false,
    },
    {
      url: '/integrations',
      label: t('menuEinvoice.integrations'),
      icon: () => <StoresIcon selected={location.pathname.startsWith('/integrations')} />,
      badge: printMessagesCount(newMessagesCount.sites),
      selected: location.pathname.startsWith('/integrations'),
      isTaxAgentMainVisible: false,
    },
  ]
}
